// Saber Legacy — menú móvil de dos niveles (accesible, 23 sep).
(function(){
  var d = document.querySelector('[data-slm]');
  if (!d) return;
  var ov = document.createElement('div');
  ov.className = 'slm__ov';
  document.body.appendChild(ov);
  var trigger = null;
  var gate = d.querySelector('[data-slm-open2]');
  var back = d.querySelector('[data-slm-back]');
  var closeBtn = d.querySelector('.js-drawer-close');
  function setExpanded(v){
    var bs = document.querySelectorAll('.js-drawer-open-nav');
    for (var i = 0; i < bs.length; i++) bs[i].setAttribute('aria-expanded', v ? 'true' : 'false');
  }
  setExpanded(false);
  if (gate) gate.setAttribute('aria-expanded', 'false');
  d.setAttribute('role', 'dialog');
  d.setAttribute('aria-modal', 'true');
  d.setAttribute('aria-label', 'Menú');
  function focusables(){
    var pane = d.querySelector(d.classList.contains('is-n2') ? '.slm__pane--2' : '.slm__pane--1');
    return pane ? [].slice.call(pane.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])')) : [];
  }
  function go2(){
    d.classList.add('is-n2');
    if (gate) gate.setAttribute('aria-expanded', 'true');
    if (back) setTimeout(function(){ back.focus(); }, 60);
  }
  function go1(){
    var was = d.classList.contains('is-n2');
    d.classList.remove('is-n2');
    if (gate) gate.setAttribute('aria-expanded', 'false');
    if (was && gate) setTimeout(function(){ gate.focus(); }, 60);
  }
  function open(t){
    if (d.classList.contains('slm-open')) return;
    trigger = t || document.activeElement;
    d.classList.remove('is-n2');
    if (gate) gate.setAttribute('aria-expanded', 'false');
    d.classList.add('slm-open');
    ov.classList.add('is-on');
    document.body.style.overflow = 'hidden';
    setExpanded(true);
    if (closeBtn) setTimeout(function(){ closeBtn.focus(); }, 60);
  }
  function close(){
    if (!d.classList.contains('slm-open')) return;
    d.classList.remove('slm-open');
    ov.classList.remove('is-on');
    document.body.style.overflow = '';
    setExpanded(false);
    setTimeout(function(){
      d.classList.remove('is-n2');
      if (gate) gate.setAttribute('aria-expanded', 'false');
    }, 340);
    if (trigger && trigger.focus) trigger.focus();
  }
  // Atendemos la hamburguesa nosotros y no dejamos que el tema abra su propio cajón.
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('.js-drawer-open-nav');
    if (opener){
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open(opener);
      return;
    }
    if (t.closest('.js-drawer-close') && d.contains(t)){
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      close();
      return;
    }
    if (t.closest('[data-slm-open2]')){ go2(); return; }
    if (t.closest('[data-slm-back]')){ go1(); return; }
  }, true);
  ov.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if (!d.classList.contains('slm-open')) return;
    if (e.key === 'Escape'){
      if (d.classList.contains('is-n2')) { go1(); return; }
      close();
      return;
    }
    if (e.key === 'Tab'){
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
